let api = ""; // 默认npm run build打包会使用这个地址
if (process.env.NODE_ENV === "development") {
  // npm run build
  // api = "https://testoms2.szestp.com:8055"; // 谢丝慧测试环境
  // api = "http://192.168.88.176:8888"; // 谢丝慧本地
  // api = "http://192.168.88.105:8688"; // 李秀文本地
  // api = "https://testoms2.szestp.com:8081"; // 李秀文测试地址
  // api = "http://192.168.88.234:8111"; // 陈俊豪本地
  // api = "https://testoms2.szestp.com:8088"; // 钟宵测试地址
  // api = "http://192.168.88.139:8001"; // 钟宵本地地址
  // api = "http://192.168.88.186:8888"; // 郭泽豪本地地址
  // api = "http://192.168.88.227:8090"; // 王喻本地地址
  // api = "http://192.168.88.105:8688"; // 开发环境
  // api = "https://oms2.szestp.com:8099"; // 正式环境
  // api = "http://192.168.88.169:8002"; // 郭钦湜环境
  // api = "http://192.168.88.190/OMSApi"; // 胡曦阳环境
  // api = "https://testoms2.szestp.com:8803"; // 验收环境
  // api = "https://check.szestp.com:60001"; // 验收环境
  // api = "http://192.168.88.77:9968"; // 验收环境
  api = "https://check.szestp.com:1443"; // 验收环境
} else if (process.env.VUE_APP_CURRENTMODE === "test") {
  // npm run build-test
  api = "https://testoms2.szestp.com:8086"; //测试
} else if (process.env.VUE_APP_CURRENTMODE === "prod") {
  // npm run build-prod
  api = "https://oms2.szestp.com:8089"; //深圳环境
} else if (process.env.VUE_APP_CURRENTMODE === "prodPH") {
  // npm run build-prodPH
  api = "https://ph.szestp.com:8088"; //菲律宾环境
} else if (process.env.VUE_APP_CURRENTMODE === "prodHK") {
  // npm run build-prodHK
  api = "https://xg.szestp.com:8099"; //香港环境v
} else if (process.env.VUE_APP_CURRENTMODE === "prodID") {
  // npm run build-prodID
  api = "https://id.szestp.com:8095"; //印尼环境
} else if (process.env.VUE_APP_CURRENTMODE === "testHK") {
  // npm run build-testHK
  api = "https://xg.szestp.com:8081"; //香港测试环境
} else if (process.env.VUE_APP_CURRENTMODE === "tryOutHK") {
  // npm run build-tryOutHK
  api = "https://tryoms2.szestp.com:8084"; //香港试用环境
} else if (process.env.VUE_APP_CURRENTMODE === "logistics") {
  // npm run build-logistics
  api = "https://oms.supervia.com.cn:8001"; //物流环境
} else if (process.env.VUE_APP_CURRENTMODE === "checkAccept") {
  //  npm run build-checkAccept
  api = "https://testoms2.szestp.com:8803"; //验收环境
} else if (process.env.VUE_APP_CURRENTMODE === "try2Web") {
  // npm run build-try2Web
  api = "https://oms2.szestp.com:8001"; // 深圳试用
} else if (process.env.VUE_APP_CURRENTMODE === "ytb") {
  // npm run build-ytb
  api = "http://172.23.157.234:8889"; // 洋驼帮
} else if (process.env.VUE_APP_CURRENTMODE === "vn") {
  // npm run build-vn
  api = "https://vn.szestp.com:8889"; // 越南
} else if (process.env.VUE_APP_CURRENTMODE === "szSpare") {
  // npm run build-szSpare
  api = "https://omsbc2.szestp.com:8001"; // 深圳备用
} else if (process.env.VUE_APP_CURRENTMODE === "ph2") {
  // npm run build-ph2
  api = "https://ph2.szestp.com:8889"; // 菲律宾备用
} else if (process.env.VUE_APP_CURRENTMODE === "id2") {
  // npm run build-id2
  api = "https://id2.szestp.com:8889"; // 印尼备用
} else if (process.env.VUE_APP_CURRENTMODE === "th2") {
  // npm run build-th2
  api = "https://th2.szestp.com:8889"; // 泰国
}

export default api;
